export default __webpack_public_path__ + "static/media/falcon.8a9c659b.png";